import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { brothers } from "@/data/brothers";
import BrotherImage from "@/components/BrotherImage";

const fade = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

export default function BrothersPreview() {
  return (
    <section className="py-24 sm:py-32 bg-brand-surface" data-testid="brothers-preview">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-brand-terracotta text-sm uppercase tracking-[0.2em] font-semibold mb-4">
              A Global Fraternity
            </p>
            <h2 className="font-serif text-3xl sm:text-5xl text-brand-ink leading-tight max-w-xl">
              The brothers building this community
            </h2>
          </div>
          <Link
            to="/brothers"
            data-testid="brothers-preview-link"
            className="inline-flex items-center gap-2 text-brand-green font-medium hover:text-brand-terracotta transition-colors"
          >
            Meet everyone <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {brothers.map((b, i) => (
            <motion.div
              key={b.slug}
              initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
              variants={fade} custom={i}
            >
              <Link
                to={`/brothers#${b.slug}`}
                data-testid={`brother-card-${b.slug}`}
                className="group block rounded-2xl overflow-hidden bg-brand-bg border border-brand-line hover:shadow-lg transition-all duration-300"
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <BrotherImage src={b.image} name={b.name} position={b.imagePos} className="group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-5">
                  <h3 className="font-serif text-xl text-brand-ink">{b.name}</h3>
                  <p className="text-brand-terracotta text-xs uppercase tracking-wider mt-1">{b.location}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
